<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <div class="row">
                <div style="width: 100%; display: flex; justify-content: space-between;">
                  <h4 style="padding-left: 15px;" class="card-title">Lista de Tickets</h4>
                  <div style="padding-right: 15px;">
                    <vs-tooltip text="Crear ticket" color="primary">
                      <vs-button @click.prevent="openCreatePopup()" color="primary" type="filled"
                        icon="add"></vs-button>
                    </vs-tooltip>
                  </div>
                </div>
                <div class="col">
                  <div style="padding-left: 15px;" class="row">
                    <div class="col-xl-2 col-md-2"><vs-input style="height: auto !important;" type="date" label="Inicio"
                        v-model="inicio" /></div>
                    <div class="col-xl-2 col-md-2"><vs-input style="height: auto !important;" type="date" label="Fin"
                        class="inputx" v-model="fin" /></div>

                    <div class="col-xl-2 col-md-2" style="align-self: flex-end;">
                      <vs-select label="Dependencia" autocomplete class="selectExample" placeholder="Seleccionar"
                        v-model="filterDependence" @change="filtrarItems()">
                        <vs-select-item :key="index" :value="item.value" :text="item.text"
                          v-for="item, index in optionsDependence" />
                      </vs-select>
                    </div>
                    <div class="col-xl-2 col-md-2" style="align-self: flex-end;">
                      <vs-select label="Conductor" class="selectExample" autocomplete placeholder="Seleccionar"
                        v-model="filterDriver" @change="filtrarItems()">
                        <vs-select-item :key="index" :value="item.value" :text="item.text"
                          v-for="item, index in optionsDriver" />
                      </vs-select>
                    </div>
                    <div class="col-xl-2 col-md-2" style="align-self: flex-end;">
                      <vs-select label="Vehiculo" class="selectExample" autocomplete placeholder="Seleccionar"
                        v-model="filterVehicle" @change="filtrarItems()">
                        <vs-select-item :key="index" :value="item.value" :text="item.text"
                          v-for="item, index in optionsVehicle" />
                      </vs-select>
                    </div>
                    <div class="col-xl-2 col-md-2" style="align-self: flex-end;">
                      <vs-select label="Estado" class="selectExample" autocomplete placeholder="Seleccionar"
                        v-model="filterStatus" @change="filtrarItems()">
                        <vs-select-item :key="index" :value="item.text" :text="item.text"
                          v-for="item, index in options2" />
                      </vs-select>
                    </div>
                  </div>
                  <div style="padding-left: 15px; padding-top: 1rem;" class="row">
                    <div style="align-self: flex-end;" class="col-xl-4 col-md-4">
                      <vs-input icon="search" class="inputx" type="text" placeholder="Buscar..." v-model="search" />
                    </div>
                    <div style="align-self: flex-end;" class="col-xl-1 col-md-1">
                      <vs-tooltip text="Consultar" color="primary">
                        <vs-button style="height: auto !important; font-size: 1rem; width: 100%!important;"
                          @click="getListTicketsDate()" color="primary" type="filled" icon="search"></vs-button>
                      </vs-tooltip>
                    </div>
                    <div style="align-self: flex-end;" class="col-xl-1 col-md-1">
                      <vs-tooltip text="Limpiar" color="primary">
                        <vs-button style="height: auto !important; font-size: 1rem; width: 100%!important;"
                          @click="cleanFilters()" color="primary" type="filled" icon="cleaning_services"></vs-button>
                      </vs-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <table1 @functionComponentEdit="editTicket" @functionComponentDownload="downloadTicket"
              class="table-hover table-striped" :columns="table1.columns" :data="table1.data">
            </table1>
          </card>
        </div>
      </div>
      <vs-popup classContent="popup-example" title="Crear Ticket" :active.sync="popupCreated">
        <div class="row">
          <div class="col-xl-4 col-md-4">
            <vs-select class="selectExample" placeholder="Seleccionar" label="Método de pago"
              v-model="form.method_payment">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item, index in options1" />
            </vs-select>
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-select v-bind:disabled="!validateMethodPayment" class="selectExample" placeholder="Seleccionar"
              label="Forma de pago" v-model="form.way_to_pay">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item, index in options3" />
            </vs-select>
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input v-bind:disabled="validateMethodPayment" type="datetime-local" label="Fecha de Ejecucion"
              class="inputx" v-model="form.execution_date" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input type="number" label="Teléfono Cliente" class="inputx" placeholder=""
              v-model="form.phone_client" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Cliente" class="inputx" placeholder="Nombre" v-model="form.client" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input v-bind:disabled="validateMethodPayment" label="Solicitado Por" class="inputx"
              placeholder="Solicita..." v-model="form.name_requesting" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input v-bind:disabled="validateMethodPayment" label="Autorizado Por" class="inputx"
              placeholder="Autoriza..." v-model="form.name_authorizing" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-select class="selectExample" autocomplete v-bind:disabled="validateMethodPayment"
              placeholder="Seleccionar" label="Dependencia" v-model="form.dependence">
              <vs-select-item :key="index" :value="item.value" :text="item.text"
                v-for="item, index in optionsDependence" />
            </vs-select>
          </div>
          <div v-if="flag_dependence" class="col-xl-4 col-md-4">
            <vs-input label="Consecutivo Ferrocarril" type="number" class="inputx" placeholder="Numero..."
              v-model="form.order_number_railway" />
          </div>
          <!--<div class="col-xl-4 col-md-4">
            <vs-select autocomplete
            class="selectExample" placeholder="Seleccionar" label="Centro de Costo" v-model="form.cost_center">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item,index in optionsCostCenter" />
            </vs-select>
          </div>-->
          <div class="col-xl-4 col-md-4">
            <vs-select autocomplete class="selectExample" placeholder="Seleccionar" label="Conductor"
              v-model="form.id_driver">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item, index in optionsDriver" />
            </vs-select>
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-select autocomplete class="selectExample" placeholder="Seleccionar" label="Vehículo"
              v-model="form.id_vehicle">
              <vs-select-item :key="index" :value="item.value" :text="item.text"
                v-for="item, index in optionsVehicle" />
            </vs-select>
          </div>
          <!--<div class="col-xl-4 col-md-4">
            <vs-select autocomplete
            class="selectExample" placeholder="Seleccionar" label="Operador" v-model="form.id_operator">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item,index in optionsOperator" />
            </vs-select>
          </div>-->
          <div class="col-xl-4 col-md-4">
            <vs-input type="number" label="Tarifa Adicional" class="inputx" placeholder=""
              v-model="form.additional_fee" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Observaciones" class="inputx" placeholder="Observaciones" v-model="form.observations" />
          </div>
          <div style="display: flex; align-items: flex-end;" class="col-xl-4 col-md-4"
            v-for="(input, index) in form.inputs" :key="index">
            <vs-select autocomplete class="selectExample" placeholder="Seleccionar" label="Servicio"
              v-model="form.inputs[index]">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item, index in optionsFee" />
            </vs-select>
            <vs-button @click="removeInput(index)" color="danger" type="line">X</vs-button>
          </div>
          <div class="col-xl-12 col-md-12" style="display: flex; padding-top: 15px;">
            <div class="col-xl-4 col-md-4">
              <vs-button @click="addInput()" color="primary" type="line">+Agregar Servicio</vs-button>
            </div>
            <div class="col-xl-4 col-md-4">
              <vs-button @click="createTicket()" color="primary" type="filled">Crear Ticket</vs-button>
            </div>
          </div>
        </div>
      </vs-popup>
      <vs-popup classContent="popup-example" title="Detalle Ticket" :active.sync="popupEdit">
        <div style="margin: 0; padding-bottom: 15px;" class="row">
          <h4 style="margin: 0;"><strong>Orden #{{ formEdit.order_number }}</strong></h4>
          <div style="align-self: center;" v-if="formEdit.status == 4 && rol == 2" class="col-xl-4 col-md-4">
            <p style="margin: 0;">Cancelada</p>
          </div>
          <div v-else class="col-xl-4 col-md-4">
            <vs-select v-bind:disabled="(formEdit.status == 3 || formEdit.status == 4) && rol == 2"
              class="selectExample" placeholder="Seleccionar" v-model="formEdit.status">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item, index in options" />
            </vs-select>
          </div>
          <div style="align-self: center;" v-if="formEdit.status == 4" class="col-xl-5 col-md-5">
            <vs-input v-bind:disabled="(formEdit.status == 3 || formEdit.status == 4) && rol == 2" type="text"
              class="inputx" placeholder="Observaciones Cancelada" v-model="formEdit.observations_cancelate" />
          </div>
        </div>
        <div style="padding-bottom: 20px; font-size: 1rem;">
          <table style="width: 100%;">
            <th style="font-size: 1rem; padding: 0;">Servicio</th>
            <th style="font-size: 1rem; padding: 0;">Origen</th>
            <th style="font-size: 1rem; padding: 0;">Destino</th>
            <th style="font-size: 1rem; padding: 0;">Valor</th>
            <th style="font-size: 1rem; padding: 0;">Borrar</th>
            <tr style="border-bottom: inset;" v-for="item, index in formEdit.fees">
              <td>{{ item.fee }}</td>
              <td>{{ item.origin }}</td>
              <td>{{ item.destination }}</td>
              <td>${{ new Intl.NumberFormat("de-DE").format(item.total) }}</td>
              <td style="text-align: center;"><vs-button
                  v-bind:disabled="(formEdit.status == 3 || formEdit.status == 4) && rol == 2"
                  @click="deleteTicketDetail(item.id_ticket_detail)" color="danger" type="line">X</vs-button></td>
            </tr>
            <tr>
              <td><strong>Subtotal:</strong></td>
              <td><strong>${{ new Intl.NumberFormat("de-DE").format(formEdit.subtotal) }}</strong></td>
            </tr>
            <tr>
              <td><strong>Tarifa Adicional:</strong></td>
              <td><strong>${{ new Intl.NumberFormat("de-DE").format(formEdit.additional_fee) }}</strong></td>
            </tr>
            <tr>
              <td><strong>Total:</strong></td>
              <td><strong>${{ new Intl.NumberFormat("de-DE").format(formEdit.total) }}</strong></td>
            </tr>
          </table>
        </div>
        <div class="row">
          <div class="col-xl-4 col-md-4">
            <vs-select autocomplete v-bind:disabled="(formEdit.status == 3 || formEdit.status == 4) && rol == 2"
              class="selectExample" placeholder="Seleccionar" label="Método de pago" v-model="formEdit.method_payment">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item, index in options1" />
            </vs-select>
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-select autocomplete v-bind:disabled="(formEdit.status == 3 || formEdit.status == 4) && rol == 2"
              class="selectExample" placeholder="Seleccionar" label="Forma de pago" v-model="formEdit.way_to_pay">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item, index in options3" />
            </vs-select>
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input
              v-bind:disabled="((formEdit.status == 3 || formEdit.status == 4) && rol == 2) || validateMethodPaymentEdit"
              type="datetime-local" label="Fecha de Ejecucion" class="inputx" v-model="formEdit.execution_date" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input v-bind:disabled="(formEdit.status == 3 || formEdit.status == 4) && rol == 2" type="number"
              label="Teléfono Cliente" class="inputx" placeholder="Teléfono" v-model="formEdit.phone_client" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input v-bind:disabled="(formEdit.status == 3 || formEdit.status == 4) && rol == 2" label="Cliente"
              class="inputx" placeholder="Nombre" v-model="formEdit.client" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input
              v-bind:disabled="((formEdit.status == 3 || formEdit.status == 4) && rol == 2) || validateMethodPaymentEdit"
              label="Solicitado Por" class="inputx" placeholder="" v-model="formEdit.name_requesting" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input
              v-bind:disabled="((formEdit.status == 3 || formEdit.status == 4) && rol == 2) || validateMethodPaymentEdit"
              label="Autorizado Por" class="inputx" placeholder="" v-model="formEdit.name_authorizing" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-select autocomplete
              v-bind:disabled="((formEdit.status == 3 || formEdit.status == 4) && rol == 2) || validateMethodPaymentEdit"
              class="selectExample" placeholder="Seleccionar" label="Dependencia" v-model="formEdit.dependence">
              <vs-select-item :key="index" :value="item.value" :text="item.text"
                v-for="item, index in optionsDependence" />
            </vs-select>
          </div>
          <div v-if="formEdit.order_number_railway > 0" class="col-xl-4 col-md-4">
            <vs-input
              v-bind:disabled="((formEdit.status == 3 || formEdit.status == 4) && rol == 2) || validateMethodPaymentEdit"
              type="number" label="Consecutivo Ferrocarril" class="inputx" placeholder=""
              v-model="formEdit.order_number_railway" />
          </div>
          <!--<div class="col-xl-4 col-md-4">
            <vs-select autocomplete
            v-bind:disabled="(formEdit.status==3 || formEdit.status==4) && rol==2" class="selectExample" placeholder="Seleccionar" label="Centro de Costo" v-model="formEdit.cost_center">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item,index in optionsCostCenter" />
            </vs-select>
          </div>-->
          <div class="col-xl-4 col-md-4">
            <vs-select autocomplete v-bind:disabled="(formEdit.status == 3 || formEdit.status == 4) && rol == 2"
              class="selectExample" placeholder="Seleccionar" label="Conductor" v-model="formEdit.id_driver">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item, index in optionsDriver" />
            </vs-select>
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-select autocomplete v-bind:disabled="(formEdit.status == 3 || formEdit.status == 4) && rol == 2"
              class="selectExample" placeholder="Seleccionar" label="Vehículo" v-model="formEdit.id_vehicle">
              <vs-select-item :key="index" :value="item.value" :text="item.text"
                v-for="item, index in optionsVehicle" />
            </vs-select>
          </div>
          <!--<div class="col-xl-4 col-md-4">
            <vs-select autocomplete
            v-bind:disabled="(formEdit.status==3 || formEdit.status==4) && rol==2" class="selectExample" placeholder="Seleccionar" label="Operador" v-model="formEdit.id_operator">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item,index in optionsOperator" />
            </vs-select>
          </div>-->
          <div class="col-xl-4 col-md-4">
            <vs-input v-bind:disabled="(formEdit.status == 3 || formEdit.status == 4) && rol == 2" type="number"
              label="Tarifa Adicional" class="inputx" placeholder="Tarifa Adicional"
              v-model="formEdit.additional_fee" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input v-bind:disabled="(formEdit.status == 3 || formEdit.status == 4) && rol == 2" label="Observaciones"
              class="inputx" placeholder="Observaciones" v-model="formEdit.observations" />
          </div>
          <div style="display: flex; align-items: flex-end;" class="col-xl-4 col-md-4"
            v-for="(input, index) in formEdit.inputs" :key="index">
            <vs-select autocomplete v-bind:disabled="(formEdit.status == 3 || formEdit.status == 4) && rol == 2"
              class="selectExample" placeholder="Seleccionar" label="Servicio" v-model="formEdit.inputs[index]">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item, index in optionsFee" />
            </vs-select>
            <vs-button v-bind:disabled="(formEdit.status == 3 || formEdit.status == 4) && rol == 2"
              @click="removeInputEdit(index)" color="danger" type="line">X</vs-button>
          </div>
          <div class="col-xl-12 col-md-12" style="display: flex; padding-top: 15px;">
            <div class="col-xl-4 col-md-4">
              <vs-button v-bind:disabled="(formEdit.status == 3 || formEdit.status == 4) && rol == 2"
                @click="addInputEdit()" color="primary" type="line">+Agregar Servicio</vs-button>
            </div>
            <div class="col-xl-4 col-md-4">
              <vs-button @click="updateTicket()" color="primary" type="filled">Actualizar Ticket</vs-button>
            </div>
          </div>
        </div>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import Table1 from 'src/components/TableTickets.vue'
import Card from 'src/components/Cards/Card.vue'
import Vue from 'vue'
import vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'
import 'material-icons/iconfont/material-icons.css'
import getSecret from '../helpers/get-secret';
const serverUrl = getSecret('SERVER_URL');
Vue.use(vuesax)
const tableColumns = ['Numero', 'Dependencia', 'Conductor', 'Vehículo', 'Cliente', 'Valor', 'Estado', 'Fecha']
export default {
  components: {
    Table1,
    Card
  },
  data() {
    return {
      search: '',
      dateNow: null,
      inicio: '',
      fin: '',
      id_company: JSON.parse(localStorage.getItem('jwt_licencia')).id_company,
      counter: JSON.parse(localStorage.getItem('jwt_licencia')).counter,
      popupCreated: false,
      popupEdit: false,
      validateMethodPayment: false,
      validateMethodPaymentEdit: false,
      filter: 10,
      filterDependence: null,
      filterDriver: null,
      filterStatus: null,
      filterVehicle: null,
      rol: JSON.parse(localStorage.getItem('jwt_user')).rol,
      data: [],
      flag_dependence: false,
      form: {
        inputs: [{}],
        client: '',
        additional_fee: 0,
        cost_center: 'NA',
        way_to_pay: '',
        phone_client: '',
        dependence: '',
        name_requesting: '',
        name_authorizing: '',
        order_number_railway: null,
        execution_date: null,
        id_company: JSON.parse(localStorage.getItem('jwt_licencia')).id_company,
        id_operator: JSON.parse(localStorage.getItem('jwt_user')).name,
      },
      formEdit: {
        inputs: [],
        client: '',
        order_number: '',
        order_number_railway: null,
        total: 0,
        status: 1,
        way_to_pay: '',
        method_payment: '',
        dependence: '',
        name_requesting: '',
        name_authorizing: '',
        observations_cancelate: '',
        id_company: JSON.parse(localStorage.getItem('jwt_licencia')).id_company,
      },
      options: [
        { text: 'Creada', value: 1 },
        { text: 'En Ejecución', value: 2 },
        { text: 'Finalizada', value: 3 },
        { text: 'Cancelada', value: 4 },
      ],
      options1: [
        { text: 'Contado', value: 1 },
        { text: 'Crédito', value: 2 },
      ],
      options2: [
        { text: 'Todos', value: 10 },
        { text: 'Creada', value: 1 },
        { text: 'En Ejecución', value: 2 },
        { text: 'Finalizada', value: 3 },
        { text: 'Cancelada', value: 4 },
      ],
      options3: [
        { text: 'QR', value: 'QR' },
        { text: 'Efectivo', value: 'Efectivo' },
        { text: 'Transferencia', value: 'Transferencia' }
      ],
      optionsDependence: [],
      optionsCostCenter: [],
      optionsDriver: [],
      optionsVehicle: [],
      optionsFee: [],
      optionsOperator: [],
      table1: {
        columns: [...tableColumns],
        data: []
      },
    }
  },
  watch: {
    "form.phone_client": function (val) {
      if (val.length > 9) this.searchClient(val);
    },
    "form.execution_date": function (val) {
      const dateVal = new Date(val);
      if (dateVal.setHours(dateVal.getHours() + 0) > this.dateMax) {
        const dateValMax = new Date(this.dateMax);
        const dia1 = String(dateValMax.getDate()).padStart(2, '0');
        const mes1 = String(dateValMax.getMonth() + 1).padStart(2, '0');
        const anio1 = dateValMax.getFullYear();
        const date1 = `${anio1}-${mes1}-${dia1}`;
        const hours1 = dateValMax.getHours();
        const minutes1 = dateValMax.getMinutes();
        const hour1 = `${hours1}:${minutes1}`;
        this.form.execution_date = date1 + 'T' + hour1;
      } else {
        const dateValMin = new Date();
        if (dateVal < dateValMin) {
          this.form.execution_date = this.dateNow;
        }
      }
    },
    search: function (val) {
      this.filtrarItems();
    },
    "form.method_payment": function (val) {
      if (val == '1') {
        this.validateMethodPayment = true;
        this.form.dependence = 'Contado';
        this.form.name_requesting = 'NA';
        this.form.name_authorizing = 'NA';
        this.form.execution_date = this.dateNow;
      } else {
        this.validateMethodPayment = false;
        this.form.dependence = '';
        this.form.name_requesting = '';
        this.form.name_authorizing = '';
        this.form.way_to_pay = '';
      }
    },
    "formEdit.method_payment": function (val) {
      if (val == 'Contado' || val == '1') {
        this.validateMethodPaymentEdit = true;
        this.formEdit.dependence = 'Contado';
        this.formEdit.name_requesting = 'NA';
        this.formEdit.name_authorizing = 'NA';
      } else {
        this.validateMethodPaymentEdit = false;
      }
    },
    "form.dependence": function (val) {
      if (val.toLowerCase().includes('ferrocarril')) {
        this.flag_dependence = true;
      } else {
        this.flag_dependence = false;
        this.order_number_railway = null;
      }
    }
  },
  computed: {
    validatorForm() {
      if (this.form.client == '' || this.form.client == undefined || this.form.client == null) return false;
      if (this.form.observations == '' || this.form.observations == undefined || this.form.observations == null) return false;
      if (this.form.cost_center == '' || this.form.cost_center == undefined || this.form.cost_center == null) return false;
      if (this.form.dependence == '' || this.form.dependence == undefined || this.form.dependence == null) return false;
      if (this.form.id_driver == '' || this.form.id_driver == undefined || this.form.id_driver == null) return false;
      if (this.form.id_vehicle == '' || this.form.id_vehicle == undefined || this.form.id_vehicle == null) return false;
      if (this.form.method_payment == '' || this.form.method_payment == undefined || this.form.method_payment == null) return false;
      if (this.form.name_authorizing == '' || this.form.name_authorizing == undefined || this.form.name_authorizing == null) return false;
      if (this.form.name_requesting == '' || this.form.name_requesting == undefined || this.form.name_requesting == null) return false;
      if (this.form.phone_client == '' || this.form.phone_client == undefined || this.form.phone_client == null) return false;
      if (this.form.method_payment == '1') {
        if (this.form.way_to_pay == '' || this.form.way_to_pay == undefined || this.form.way_to_pay == null) return false;
      }
      if (this.flag_dependence) {
        if (this.form.order_number_railway == '' || this.form.order_number_railway == undefined || this.form.order_number_railway == null) return false;
      }
      return true;
    },
    validatorFormEdit() {
      if (this.formEdit.client == '' || this.formEdit.client == undefined || this.formEdit.client == null) return false;
      if (this.formEdit.dependence == '' || this.formEdit.dependence == undefined || this.formEdit.dependence == null) return false;
      if (this.formEdit.id_driver == '' || this.formEdit.id_driver == undefined || this.formEdit.id_driver == null) return false;
      if (this.formEdit.id_vehicle == '' || this.formEdit.id_vehicle == undefined || this.formEdit.id_vehicle == null) return false;
      if (this.formEdit.method_payment == '' || this.formEdit.method_payment == undefined || this.formEdit.method_payment == null) return false;
      if (this.formEdit.name_authorizing == '' || this.formEdit.name_authorizing == undefined || this.formEdit.name_authorizing == null) return false;
      if (this.formEdit.name_requesting == '' || this.formEdit.name_requesting == undefined || this.formEdit.name_requesting == null) return false;
      if (this.formEdit.phone_client == '' || this.formEdit.phone_client == undefined || this.formEdit.phone_client == null) return false;
      return true;
    }
  },
  methods: {
    cleanFilters() {
      this.filterDependence = null;
      this.filterDriver = null;
      this.filterStatus = null;
      this.filterVehicle = null;
      this.filtrarItems();
    },
    downloadTicket(item) {
      let url2 = serverUrl;
      let url3 = `${url2}/api/getViewTicket/${item.id_ticket}`;
      window.open(url3, '_blank');
    },
    searchClient(phone) {
      this.$vs.loading({
        type: 'radius',
        color: 'primary',
        text: "Buscando cliente por el teléfono..."
      })
      this.axios.get(serverUrl + '/api/searchClient/' + phone + '/' + this.id_company)
        .then(res => {
          if (res.data.client) {
            this.form.client = res.data.client.name;
          }
          this.$vs.loading.close()
        })
        .catch(err => {
          console.log(err);
          this.$vs.loading.close();
        });
    },
    addInput() {
      this.form.inputs.push('');
    },
    addInputEdit() {
      this.formEdit.inputs.push('');
    },
    removeInput(index) {
      if (index !== -1) {
        this.form.inputs.splice(index, 1);
      }
    },
    removeInputEdit(index) {
      if (index !== -1) {
        this.formEdit.inputs.splice(index, 1);
      }
    },
    filtrarItems() {
      const search = this.search ? this.search.toLowerCase() : '';
      const filterDependence = this.filterDependence;
      const filterDriver = this.filterDriver;
      const filterStatus = this.filterStatus;
      const filterVehicle = this.filterVehicle;

      this.table1.data = this.data.filter(item => {
        const matchesSearch = search
          ? item.client.toLowerCase().includes(search) || String(item.order_number).includes(search)
          : true;

        const matchesDependence = filterDependence
          ? item.dependencia.includes(filterDependence)
          : true;

        const matchesDriver = filterDriver
          ? item.conductor.includes(filterDriver)
          : true;

        const matchesStatus = filterStatus
          ? item.estado.includes(filterStatus)
          : true;

        const matchesVehicle = filterVehicle
          ? item.vehicle.includes(filterVehicle)
          : true;

        return matchesSearch && matchesDependence && matchesDriver && matchesStatus && matchesVehicle;
      });
    },
    getListTicketsDate() {
      this.$vs.loading({
        type: 'radius',
        color: 'primary'
      })
      this.cleanFilters();
      this.axios.get(serverUrl + '/api/getListTicketsDateV2/' + this.id_company + '/' + this.inicio + '/' + this.fin + '/' + this.filter)
        .then(res => {
          if (res.data.status == 200) {
            this.data = res.data.tickets;
            this.table1.data = res.data.tickets;
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Consulta realizada con Éxito.</span>`,
              icon: 'nc-icon nc-send',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'info'
            })
            this.$vs.loading.close();
          } else {
            console.log('Error getListTicketsDate');
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>al realizar la consulta.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'danger'
            })
            this.$vs.loading.close();
          }
        })
        .catch(err => {
          console.log('Error getListTicketsDate');
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>al realizar la consulta.</span>`,
            icon: 'nc-icon nc-support-17',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'danger'
          })
          this.$vs.loading.close();
        });
    },
    openCreatePopup() {
      const newDate = new Date();
      const dia = String(newDate.getDate()).padStart(2, '0');
      const mes = String(newDate.getMonth() + 1).padStart(2, '0');
      const anio = newDate.getFullYear();
      const date = `${anio}-${mes}-${dia}`;
      const hours = String(newDate.getHours()).padStart(2, '0');
      const minutes = String(newDate.getMinutes()).padStart(2, '0');
      const hour = `${hours}:${minutes}`;
      this.form.execution_date = date + 'T' + hour;
      this.dateNow = date + 'T' + hour;
      this.dateMax = newDate.setHours(newDate.getHours() + 72);
      this.popupCreated = true;
    },
    getListDrivers() {
      this.axios.get(serverUrl + '/api/getListActiveDrivers/' + this.id_company)
        .then(res => {
          if (res.data.status == 200) {
            res.data.drivers.forEach(detail => {
              this.driver = { text: detail.name, value: detail.name };
              this.optionsDriver.push(this.driver);
            });
          } else {
            console.log('Error getListDrivers');
          }
        })
        .catch(err => {
          console.log('Error getListDrivers');
        });
    },
    getListOperators() {
      this.axios.get(serverUrl + '/api/getListActiveOperators/' + this.id_company)
        .then(res => {
          if (res.data.status == 200) {
            res.data.operators.forEach(detail => {
              this.operator = { text: detail.name, value: detail.name };
              this.optionsOperator.push(this.operator);
            });
          } else {
            console.log('Error getListOperator');
          }
        })
        .catch(err => {
          console.log('Error getListOperator');
        });
    },
    getListFee() {
      this.axios.get(serverUrl + '/api/getListActiveFee/' + this.id_company)
        .then(res => {
          if (res.data.status == 200) {
            res.data.fees.forEach(detail => {
              this.fee = { text: detail.name, value: detail.id_fee };
              this.optionsFee.push(this.fee);
            });
          } else {
            console.log('Error getListFee');
          }
        })
        .catch(err => {
          console.log('Error getListFee');
        });
    },
    getListVehicle() {
      this.axios.get(serverUrl + '/api/getListActiveVehicle/' + this.id_company)
        .then(res => {
          if (res.data.status == 200) {
            res.data.vehicles.forEach(detail => {
              this.vehicle = { text: detail.placa, value: detail.placa };
              this.optionsVehicle.push(this.vehicle);
            });
          } else {
            console.log('Error getListVehicle');
          }
        })
        .catch(err => {
          console.log('Error getListVehicle');
        });
    },
    /*getListCostCenter(){
      this.axios.get('https://backtickets.isolutions.website/api/getListActiveCostCenter/'+this.id_company)
        .then(res => {
          if(res.data.status == 200){
            res.data.costCenters.forEach(detail => {
              this.costCenter={text:detail.name,value:detail.name};
              this.optionsCostCenter.push(this.costCenter);
            });
          }else {
            console.log('Error getListCostCenter');
          }
        })
        .catch(err => {
          console.log('Error getListCostCenter');
        });
    },*/
    getListDependence() {
      this.axios.get(serverUrl + '/api/getListActiveDependence/' + this.id_company)
        .then(res => {
          if (res.data.status == 200) {
            res.data.dependences.forEach(detail => {
              this.dependence = { text: detail.name, value: detail.name };
              this.optionsDependence.push(this.dependence);
            });
          } else {
            console.log('Error getListDependence');
          }
        })
        .catch(err => {
          console.log('Error getListDependence');
        });
    },
    createTicket() {
      this.$vs.loading({
        type: 'radius',
        color: 'primary',
        text: "Ejecutando..."
      })
      if (this.validatorForm) {
        this.axios.post(serverUrl + '/api/createTicket', this.form)
          .then(res => {
            this.popupCreated = false;
            if (res.data.status == 200) {
              this.$notifications.notify({
                message: `<span><b>¡Éxito!</b><br>Ticket Creado con Éxito.</span>`,
                icon: 'nc-icon nc-send',
                horizontalAlign: 'right',
                verticalAlign: 'bottom',
                type: 'info'
              })
              this.form.client = null;
              this.form.dependence = null;
              this.form.id_driver = null;
              this.form.id_vehicle = null;
              this.form.method_payment = null;
              this.form.name_authorizing = null;
              this.form.name_requesting = null;
              this.form.observations = null;
              this.form.order_number_railway = null;
              this.form.phone_client = '';
              this.form.additional_fee = 0;
              this.form.inputs = [];
              this.form.inputs.push('');
              this.id_company = JSON.parse(localStorage.getItem('jwt_licencia')).id_company;
              this.getListTicketsDate();
              this.$vs.loading.close();
            } else {
              this.$notifications.notify({
                message: `<span><b>¡Error!</b><br>No se pudo Crear el Ticket, inténtelo nuevamente.</span>`,
                icon: 'nc-icon nc-support-17',
                horizontalAlign: 'right',
                verticalAlign: 'bottom',
                type: 'danger'
              })
              this.$vs.loading.close();
            }
          })
          .catch(err => {
            this.popupCreated = false;
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>No se pudo Crear el Ticket, inténtelo nuevamente.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'danger'
            })
            this.$vs.loading.close();
          });
      } else {
        setTimeout(this.closeLoading, 500);
        this.$notifications.notify({
          message: `<span><b>¡Error!</b><br>No se pudo Crear el Ticket, debe completar todos los campos.</span>`,
          icon: 'nc-icon nc-support-17',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'danger'
        })
      }
    },
    editTicket(item) {
      this.formEdit.total = 0;
      this.formEdit.subtotal = 0;
      this.formEdit.id_ticket = item.id_ticket;
      this.formEdit.client = item.client;
      this.formEdit.dependence = item.dependence;
      this.formEdit.id_driver = item.driver;
      this.formEdit.id_vehicle = item.vehicle;
      this.formEdit.method_payment = item.method_payment;
      this.formEdit.name_authorizing = item.name_authorizing;
      this.formEdit.name_requesting = item.name_requesting;
      this.formEdit.execution_date = item.execution_date;
      this.formEdit.observations = item.observations;
      this.formEdit.phone_client = item.phone_client;
      this.formEdit.fees = item.ticket_details;
      this.formEdit.order_number = item.order_number;
      this.formEdit.additional_fee = item.additional_fee;
      this.formEdit.status = item.status;
      this.formEdit.way_to_pay = item.way_to_pay;
      this.formEdit.order_number_railway = item.order_number_railway;
      this.formEdit.observations_cancelate = item.observations_cancelate;
      this.formEdit.inputs = [];
      this.formEdit.fees.forEach((d) => {
        this.formEdit.subtotal += parseFloat(d.total);
      })
      this.formEdit.total = this.formEdit.subtotal + parseFloat(item.additional_fee)
      this.popupEdit = true;
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    updateTicket() {
      this.$vs.loading({
        type: 'radius',
        color: 'primary'
      })
      if (this.formEdit.status == 4 && (this.formEdit.observations_cancelate == '' || this.formEdit.observations_cancelate == null || this.formEdit.observations_cancelate == undefined)) {
        this.popupEdit = false;
        this.$notifications.notify({
          message: `<span><b>¡Error!</b><br>No se pudo Editar el Ticket, debe ingresar una observación para cancelarlo.</span>`,
          icon: 'nc-icon nc-support-17',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'danger'
        })
        setTimeout(this.closeLoading, 500);
      } else {
        if (this.validatorFormEdit) {
          this.axios.post(serverUrl + '/api/editTicket', this.formEdit)
            .then(res => {
              this.popupEdit = false;
              if (res.data.status == 200) {
                this.$notifications.notify({
                  message: `<span><b>¡Éxito!</b><br>Ticket Actualizado con Éxito.</span>`,
                  icon: 'nc-icon nc-send',
                  horizontalAlign: 'right',
                  verticalAlign: 'bottom',
                  type: 'info'
                })
                this.getListTicketsDate();
                this.$vs.loading.close();
              } else {
                this.$notifications.notify({
                  message: `<span><b>¡Error!</b><br>No se pudo Actualizar el Ticket, inténtelo nuevamente.</span>`,
                  icon: 'nc-icon nc-support-17',
                  horizontalAlign: 'right',
                  verticalAlign: 'bottom',
                  type: 'danger'
                })
                this.$vs.loading.close();
              }
            })
            .catch(err => {
              this.popupEdit = false;
              this.$notifications.notify({
                message: `<span><b>¡Error!</b><br>No se pudo Actualizar el Ticket, inténtelo nuevamente.</span>`,
                icon: 'nc-icon nc-support-17',
                horizontalAlign: 'right',
                verticalAlign: 'bottom',
                type: 'danger'
              })
              this.$vs.loading.close();
            });
        } else {
          this.popupEdit = false;
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>No se pudo Actualizar el Ticket, debe completar todos los campos.</span>`,
            icon: 'nc-icon nc-support-17',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'danger'
          })
          this.$vs.loading.close();
        }
        setTimeout(this.closeLoading, 500);
      }
    },
    deleteTicketDetail(item) {
      this.$vs.loading({
        type: 'radius',
        color: 'primary'
      })
      this.axios.get(serverUrl + '/api/deleteTicketDetail/' + item + '/' + this.formEdit.id_ticket)
        .then(res => {
          if (res.data.status == 200) {
            this.getListTicketsDate();
            this.popupEdit = false;
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Servicio eliminado con Éxito.</span>`,
              icon: 'nc-icon nc-send',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'info'
            })
            this.$vs.loading.close();
          } else {
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>al eliminar el servicio.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'danger'
            })
            this.$vs.loading.close();
          }
        })
        .catch(err => {
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>al eliminar el servicio.</span>`,
            icon: 'nc-icon nc-support-17',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'danger'
          })
          this.$vs.loading.close();
        });
    },
    validateStatus() {
      this.axios.get(serverUrl + '/api/validateStatus/' + this.id_company)
        .then(res => {
          if (res.data.info.licencia.status_commercial == 'MORA') {
            window.localStorage.removeItem('jwt_user');
            window.localStorage.removeItem('jwt_licencia');
            window.localStorage.removeItem('jwt_token');
            location.href = location.origin + '/#/login';
          } else {
            let tipo = {
              "name": res.data.info.licencia.name,
              "id_company": res.data.info.licencia.id_company,
              "payment_data": res.data.info.licencia.payment_data,
              "status_commercial": res.data.info.licencia.status_commercial,
              "counter": res.data.info.licencia.counter,
            }
            window.localStorage.setItem('jwt_licencia', JSON.stringify(tipo));
            if (this.counter != res.data.info.licencia.counter) location.reload();
          }
        })
        .catch(err => {
          console.log(err);
        })
    }
  },
  created() {
    const date = new Date();
    const dia = String(date.getDate()).padStart(2, '0');
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const anio = date.getFullYear();
    this.inicio = `${anio}-${mes}-${dia}`;
    this.fin = `${anio}-${mes}-${dia}`;
  },
  mounted() {
    this.getListTicketsDate();
    this.getListDrivers();
    this.getListOperators();
    this.getListFee();
    this.getListVehicle();
    //this.getListCostCenter();
    this.getListDependence();
    this.validateStatus();
    if (this.rol == 2) {
      this.options = [
        { text: 'Creada', value: 1 },
        { text: 'En Ejecución', value: 2 },
        { text: 'Finalizada', value: 3 }
      ];
    }
  }
}
</script>
<style>
input {
  height: auto !important;
}

.selectExample {
  height: auto !important;
  width: auto !important;
}

.card label {
  text-transform: none !important;
  ;
}

td {
  padding-right: 15px;
}
</style>
